import { ManufacturingMethod } from '../models/enums';

export const DRAW_DIRECTION_AXES = ['xp', 'yp', 'zp', 'xm', 'ym', 'zm'] as const;
export type DrawDirectionAxis = (typeof DRAW_DIRECTION_AXES)[number];
export type DrawDirectionFlags = Record<DrawDirectionAxis, boolean>;

const OPPOSITE: Record<DrawDirectionAxis, DrawDirectionAxis> = {
  xp: 'xm',
  yp: 'ym',
  zp: 'zm',
  xm: 'xp',
  ym: 'yp',
  zm: 'zp'
};

/**
 * EDITORGUI-120. The stored `drawDirectionVector` is always the direction the
 * PART is removed in — the optimizer, the XML and every other reader rely on
 * that. A die-casting project can instead be viewed and edited in terms of the
 * direction the MOLD is removed in, which is the opposite axis. Only the
 * editor's view changes; the stored value never does.
 */
export function isMoldRemovalView(
  project: { manufacturingMethod?: string; drawDirectionIsMoldRemoval?: boolean } | null | undefined
): boolean {
  return project?.manufacturingMethod === ManufacturingMethod.DieCasting && project.drawDirectionIsMoldRemoval === true;
}

/** The stored (part removal) axis for the axis ticked in the panel. */
export function storedDrawAxis(shown: DrawDirectionAxis, moldRemoval: boolean): DrawDirectionAxis {
  return moldRemoval ? OPPOSITE[shown] : shown;
}

/** The flags as the panel shows them. */
export function shownDrawDirection(
  stored: Partial<DrawDirectionFlags> | null | undefined,
  moldRemoval: boolean
): DrawDirectionFlags {
  const shown = {} as DrawDirectionFlags;
  for (const axis of DRAW_DIRECTION_AXES) shown[axis] = stored?.[storedDrawAxis(axis, moldRemoval)] === true;
  return shown;
}

export function drawDirectionHeading(method: string | undefined, moldRemoval: boolean): string {
  if (method !== ManufacturingMethod.DieCasting) return 'Draw Direction Vector';
  return moldRemoval ? 'Mold Removal Direction Vector' : 'Part Removal Direction Vector';
}
